@if ($loading()) {
<div class="mc-loading-container">
  <p-progressSpinner></p-progressSpinner>
  @if ($aguardandoAtivacao()) {
  <p>{{ 'PESSOA_MINHA_CONTA.AGUARDANDO_PAGAMENTO' | translate }}</p>
  } @else {
  <p>{{ 'PESSOAS_MODAL_DETALHE.CARREGANDO_DADOS' | translate }}</p>
  }
</div>
} @if (!$loading() && $pessoa(); as pessoa) {
<div class="mc-page-container fade-in">
  <!-- TÍTULO PRINCIPAL DA PÁGINA -->
  <header class="mc-page-header">
    <span class="mc-page-header__icon">
      <i class="pi pi-user"></i>
    </span>
    <div class="mc-page-header__left">
      <h1 class="mc-page-title">{{ 'PESSOA_MINHA_CONTA.TITULO' | translate }}</h1>
      <p class="mc-page-subtitle">
        {{ 'PESSOA_MINHA_CONTA.SUBTITULO' | translate }}
      </p>
    </div>
    @if ($nomeEstabelecimento(); as estab) {
    <div class="mc-page-header__right">
      <span class="mc-context-pill">
        <i class="pi pi-building"></i> {{ estab }}
      </span>
    </div>
    }
  </header>

  <!-- HERO CARD DO PERFIL (COM CAPA MODERNA) -->
  <section class="mc-hero-card">
    <div
      class="mc-hero-cover"
      [class.bardo-cover]="!$imagemCapaUrl() && !!$bardoContextoAtivo()"
      [class.has-custom-cover]="!!$imagemCapaUrl()"
    >
      @if ($imagemCapaUrl(); as capaUrl) {
      <img [src]="capaUrl" [alt]="'PESSOA_MINHA_CONTA.FOTO_CAPA' | translate" class="mc-hero-cover__img" />
      }
      <div class="mc-hero-cover__pattern"></div>
      @if ($nomeEstabelecimento(); as estabNome) {
      <div class="mc-hero-cover__watermark">
        <i class="pi pi-building"></i> {{ estabNome }}
      </div>
      }
    </div>

    <div class="mc-hero-body">
      <div class="mc-hero-avatar-area">
        <div class="mc-avatar-wrapper">
          @if ($imagemUrl()) {
          <img [src]="$imagemUrl()" [alt]="'PESSOA_MINHA_CONTA.FOTO_PERFIL' | translate" class="mc-avatar-img" />
          } @else {
          <p-avatar
            icon="pi pi-user"
            size="xlarge"
            shape="circle"
            styleClass="mc-fallback-avatar"
          ></p-avatar>
          }
        </div>
      </div>

      <div class="mc-hero-info">
        <div class="mc-hero-name-row">
          <h2 class="mc-user-name">{{ pessoa.nome }}</h2>
          @if ($papelFormatado(); as papel) {
          <span class="mc-role-badge" [class.is-dono]="isDonoBardo">
            <i [class]="isDonoBardo ? 'pi pi-star-fill' : 'pi pi-shield'"></i>
            {{ papel | translate }}
          </span>
          }
        </div>

        @if ($nomeEstabelecimento(); as estab) {
        <div class="mc-hero-badges">
          <span class="mc-badge mc-badge--estab">
            <i class="pi pi-building"></i> {{ estab }}
          </span>
        </div>
        }
      </div>

      <div class="mc-hero-actions">
        <button
          pButton
          icon="pi pi-user-edit"
          class="p-button-outlined p-button-secondary mc-btn-edit"
          (click)="onEditarPerfil()"
        >
          {{ 'PESSOA_MINHA_CONTA.EDITAR_PERFIL' | translate }}
        </button>
      </div>
    </div>
  </section>

  <!-- VÍNCULO PROFISSIONAL NO BARDO (QUANDO FOR FUNCIONÁRIO / PROFISSIONAL) -->
  @if ($isProfissionalBardo() && $nomeEstabelecimento(); as estab) {
  <div class="mc-bardo-vinculo-card fade-in">
    <div class="mc-bardo-vinculo-icon">
      <i class="pi pi-briefcase"></i>
    </div>
    <div class="mc-bardo-vinculo-content">
      <h3>{{ 'PESSOA_MINHA_CONTA.VINCULO_BARDO.TITULO' | translate }}</h3>
      <p [innerHTML]="'PESSOA_MINHA_CONTA.VINCULO_BARDO.DESCRICAO' | translate:{ papel: ($papelFormatado()! | translate), estab: estab }"></p>
    </div>
  </div>
  }

  <!-- BANNER DE AVISO: PLANO EXPIRADO -->
  @if ($avisoExpirado()) {
  <div class="mc-aviso-expirado">
    <i class="pi pi-exclamation-triangle"></i>
    <span [innerHTML]="'PESSOA_MINHA_CONTA.AVISOS.EXPIRADO' | translate:{ sistema: $sistemaExpiradoNome() }"></span>
  </div>
  }

  <!-- BANNER DE AVISO: PLANO CANCELADO -->
  @if ($avisoCancelado()) {
  <div class="mc-aviso-expirado">
    <i class="pi pi-exclamation-triangle"></i>
    <span [innerHTML]="'PESSOA_MINHA_CONTA.AVISOS.CANCELADO' | translate:{ sistema: $sistemaExpiradoNome() }"></span>
  </div>
  }

  <div class="mc-grid-layout">
    <!-- LINK DE AJUDA E SUPORTE -->
    @if (mostrarAjudaSuporte) {
    <button type="button" class="mc-help-link" (click)="onAcessarAjuda()">
      <span class="mc-help-link__icon">
        <i class="pi pi-question-circle"></i>
      </span>
      <span class="mc-help-link__content">
        <strong>{{ 'PESSOA_MINHA_CONTA.AJUDA_SUPORTE.TITULO' | translate }}</strong>
        <small>{{ 'PESSOA_MINHA_CONTA.AJUDA_SUPORTE.SUBTITULO' | translate }}</small>
      </span>
      <i class="pi pi-chevron-right mc-help-link__arrow"></i>
    </button>
    }

    <!-- MEUS SISTEMAS -->
    @if (mostrarMeusSistemas) {
    <section class="mc-systems-section">
      <h2 class="mc-section-title">
        <i class="pi pi-th-large"></i> {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.TITULO' | translate }}
      </h2>

      <div class="mc-cards-grid">
        <!-- CARD NOMOH -->
        @if ($temPlanoNomoh()) {
        <div class="mc-system-card nomoh-theme">
          <div class="mc-card-header">
            <div class="mc-card-icon">
              <i class="pi pi-server"></i>
            </div>
            <div class="mc-card-title-group">
              <h3>Nomoh Admin</h3>
              <span class="mc-plan-name">{{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.PLANO' | translate }}: <strong>{{ $planoNomohInfo()?.nome }}</strong></span>
            </div>
          </div>

          <div class="mc-card-info">
            @if ($planoNomohStatus()) {
            <div class="mc-card-status">
              <p-tag
                [value]="$planoNomohStatus()!.labelKey | translate:$planoNomohStatus()!.labelParams"
                [severity]="$planoNomohStatus()!.severity"
              ></p-tag>
            </div>
            @if ($planoNomohStatus()!.isPending) {
            <div class="mc-pending-notice">
              <small
                ><i class="pi pi-clock"></i> {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.AGUARDANDO_STRIPE' | translate }}</small
              >
            </div>
            } @if ($proximaCobrancaNomoh()) {
            <div class="mc-proxima-cobranca">
              <small
                ><i class="pi pi-sync"></i> {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.RENOVA_EM' | translate:{ data: $proximaCobrancaNomoh() } }}</small
              >
            </div>
            } }
          </div>

          <div class="mc-card-actions">
            <button
              pButton
              icon="pi pi-external-link"
              class="p-button-rounded mc-btn-access"
              (click)="onAcessarNomoh()"
              [disabled]="$planoNomohStatus()?.blockAccess"
            >
              {{
                ($planoNomohStatus()?.isPending
                  ? 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.AGUARDANDO_PAGAMENTO'
                  : $planoNomohStatus()?.blockAccess
                  ? 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.SISTEMA_INDISPONIVEL'
                  : 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.ACESSAR_SISTEMA') | translate
              }}
            </button>
            @if ($planoNomohStatus()?.blockAccess) {
            <button
              pButton
              icon="pi pi-refresh"
              class="p-button-rounded p-button-outlined mc-btn-renovar"
              (click)="abrirModalRenovar($planoNomohInfo()?.sistemaId ?? null)"
            >
              {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.RENOVAR' | translate }}
            </button>
            } @if ($planoNomohInfo()?.stripeSubscriptionId &&
            !$planoNomohStatus()?.isPending) {
            <button
              pButton
              icon="pi pi-credit-card"
              class="p-button-rounded p-button-outlined mc-btn-portal"
              [loading]="$loadingPortal()"
              (click)="abrirGerenciamentoAssinatura()"
            >
              {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.GERENCIAR_ASSINATURA' | translate }}
            </button>
            }
          </div>
        </div>
        }

        <!-- CARD BARDO -->
        @if ($temPlanoBardo()) {
        <div class="mc-system-card bardo-theme">
          <div class="mc-card-header">
            <div class="mc-card-icon">
              <i class="pi pi-calendar-plus"></i>
            </div>
            <div class="mc-card-title-group">
              <h3>Bardo Reservas</h3>
              <span class="mc-plan-name">{{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.PLANO' | translate }}: <strong>{{ $planoBardoInfo()?.nome }}</strong></span>
            </div>
          </div>

          <div class="mc-card-info">
            @if ($planoBardoStatus()) {
            <div class="mc-card-status">
              <p-tag
                [value]="$planoBardoStatus()!.labelKey | translate:$planoBardoStatus()!.labelParams"
                [severity]="$planoBardoStatus()!.severity"
              ></p-tag>
            </div>
            @if ($planoBardoStatus()!.isPending) {
            <div class="mc-pending-notice">
              <small
                ><i class="pi pi-clock"></i> {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.AGUARDANDO_STRIPE' | translate }}</small
              >
            </div>
            } @if ($proximaCobrancaBardo()) {
            <div class="mc-proxima-cobranca">
              <small
                ><i class="pi pi-sync"></i> {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.RENOVA_EM' | translate:{ data: $proximaCobrancaBardo() } }}</small
              >
            </div>
            } }
          </div>

          <div class="mc-card-actions">
            <button
              pButton
              icon="pi pi-external-link"
              class="p-button-rounded mc-btn-access bardo-btn"
              (click)="onAcessarBardo()"
              [disabled]="$planoBardoStatus()?.blockAccess"
            >
              {{
                ($planoBardoStatus()?.isPending
                  ? 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.AGUARDANDO_PAGAMENTO'
                  : $planoBardoStatus()?.blockAccess
                  ? 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.SISTEMA_INDISPONIVEL'
                  : 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.ACESSAR_SISTEMA') | translate
              }}
            </button>
            @if ($planoBardoStatus()?.blockAccess) {
            <button
              pButton
              icon="pi pi-refresh"
              class="p-button-rounded p-button-outlined mc-btn-renovar"
              (click)="abrirModalRenovar($planoBardoInfo()?.sistemaId ?? null)"
            >
              {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.RENOVAR' | translate }}
            </button>
            } @if ($planoBardoInfo()?.stripeSubscriptionId &&
            !$planoBardoStatus()?.isPending) {
            <button
              pButton
              icon="pi pi-credit-card"
              class="p-button-rounded p-button-outlined mc-btn-portal"
              [loading]="$loadingPortal()"
              (click)="abrirGerenciamentoAssinatura()"
            >
              {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.GERENCIAR_ASSINATURA' | translate }}
            </button>
            }
          </div>
        </div>
        } @else {
        <!-- COMPRAR BARDO CTA -->
        <div class="mc-system-card buy-bardo-theme">
          <div class="mc-card-header">
            <div class="mc-card-icon">
              <i class="pi pi-sparkles"></i>
            </div>
            <div class="mc-card-title-group">
              <h3>{{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.BARDO_TITULO' | translate }}</h3>
              <p class="mc-card-desc">
                {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.BARDO_DESC' | translate }}
              </p>
            </div>
          </div>

          <div class="mc-card-actions">
            <button
              pButton
              icon="pi pi-sparkles"
              class="p-button-rounded mc-btn-buy"
              [loading]="$loadingBardo()"
              (click)="onComprarPlanoBardo()"
            >
              {{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.EXPERIMENTAR_GRATIS' | translate }}
            </button>
            <small class="mc-trial-hint">{{ 'PESSOA_MINHA_CONTA.MEUS_SISTEMAS.TRIAL_HINT' | translate }}</small>
          </div>
        </div>
        }
      </div>
    </section>
    }

    <!-- SEGURANÇA -->
    @if (!pessoa.contaOAuth) {
    <section class="mc-details-section">
      <h2 class="mc-section-title">
        <i class="pi pi-shield"></i> {{ 'PESSOA_MINHA_CONTA.SEGURANCA.TITULO' | translate }}
      </h2>
      <div class="mc-details-card mc-security-card">
        <div class="mc-security-info">
          <strong>{{ 'PESSOA_MINHA_CONTA.SEGURANCA.SENHA_CONTA' | translate }}</strong>
          <small>{{ 'PESSOA_MINHA_CONTA.SEGURANCA.SENHA_CONTA_DESC' | translate }}</small>
        </div>
        <button
          pButton
          icon="pi pi-lock"
          class="p-button-outlined"
          (click)="abrirRedefinirSenha()"
        >
          {{ 'PESSOA_MINHA_CONTA.SEGURANCA.REDEFINIR_SENHA' | translate }}
        </button>
      </div>
    </section>
    }

    <!-- DADOS PESSOAIS E ENDEREÇO (CARDS DUPLEIS COMPACTOS E ELEGANTES) -->
    <section class="mc-details-section">
      <div class="mc-details-dual-grid">
        <!-- CARD 1: INFORMAÇÕES PESSOAIS -->
        <div class="mc-info-panel">
          <div class="mc-panel-header">
            <h2 class="mc-panel-title">
              <i class="pi pi-user text-primary"></i> {{ 'PESSOA_MINHA_CONTA.INFO_PESSOAL.TITULO' | translate }}
            </h2>
            <span class="mc-panel-badge">
              <i class="pi pi-check-circle"></i> {{ 'PESSOA_MINHA_CONTA.INFO_PESSOAL.VERIFICADO' | translate }}
            </span>
          </div>

          <div class="mc-panel-body">
            @if (pessoa.email) {
            <div class="mc-tile mc-tile--full">
              <div class="mc-tile__icon">
                <i class="pi pi-envelope"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.EMAIL' | translate }}</span>
                <span class="mc-tile__value">{{ pessoa.email }}</span>
              </div>
            </div>
            }

            @if (pessoa.telefone) {
            <div class="mc-tile">
              <div class="mc-tile__icon">
                <i class="pi pi-phone"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.TELEFONE' | translate }}</span>
                <span class="mc-tile__value">{{ formatarTelefone(pessoa.telefone) }}</span>
              </div>
            </div>
            }

            @if (pessoa.cpfCnpj) {
            <div class="mc-tile">
              <div class="mc-tile__icon">
                <i class="pi pi-id-card"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'PESSOA_MINHA_CONTA.INFO_PESSOAL.DOCUMENTO' | translate }}</span>
                <span class="mc-tile__value">{{ formatarCPFOUCNPJ(pessoa.cpfCnpj) }}</span>
              </div>
            </div>
            }

            <div class="mc-tile">
              <div class="mc-tile__icon">
                <i class="pi pi-calendar"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.DATA_INCLUSAO_CLIENTE' | translate }}</span>
                <span class="mc-tile__value">{{ formatarData(pessoa.dataInclusao?.toString()!) }}</span>
              </div>
            </div>

            @if (pessoa.sexo) {
            <div class="mc-tile">
              <div class="mc-tile__icon">
                <i [class]="pessoa.sexo === 1 ? 'pi pi-mars' : pessoa.sexo === 2 ? 'pi pi-venus' : 'pi pi-user'"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.SEXO' | translate }}</span>
                <span class="mc-tile__value">
                  @switch (pessoa.sexo) {
                    @case (1) { {{ 'GLOBAL.SEXO_MASCULINO' | translate }} }
                    @case (2) { {{ 'GLOBAL.SEXO_FEMININO' | translate }} }
                    @default { {{ 'GLOBAL.SEXO_NAO_INFORMADO' | translate }} }
                  }
                </span>
              </div>
            </div>
            }
          </div>
        </div>

        <!-- CARD 2: ENDEREÇO -->
        @if (pessoa.endereco) {
        <div class="mc-info-panel">
          <div class="mc-panel-header">
            <h2 class="mc-panel-title">
              <i class="pi pi-map-marker text-primary"></i> {{ 'PESSOA_MINHA_CONTA.ENDERECO.TITULO' | translate }}
            </h2>
            <span class="mc-panel-badge mc-panel-badge--location">
              <i class="pi pi-compass"></i> {{ 'PESSOA_MINHA_CONTA.ENDERECO.PRINCIPAL' | translate }}
            </span>
          </div>

          <div class="mc-panel-body">
            <div class="mc-tile mc-tile--full">
              <div class="mc-tile__icon">
                <i class="pi pi-home"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.LOGRADOURO' | translate }}</span>
                <span class="mc-tile__value">
                  {{ pessoa.endereco.logradouro }}@if (pessoa.endereco.numero) { , {{ pessoa.endereco.numero }} }
                </span>
              </div>
            </div>

            @if (pessoa.endereco.complemento) {
            <div class="mc-tile">
              <div class="mc-tile__icon">
                <i class="pi pi-info-circle"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.COMPLEMENTO' | translate }}</span>
                <span class="mc-tile__value">{{ pessoa.endereco.complemento }}</span>
              </div>
            </div>
            }

            <div class="mc-tile">
              <div class="mc-tile__icon">
                <i class="pi pi-compass"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.BAIRRO' | translate }}</span>
                <span class="mc-tile__value">{{ pessoa.endereco.bairro }}</span>
              </div>
            </div>

            <div class="mc-tile">
              <div class="mc-tile__icon">
                <i class="pi pi-map"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.CIDADE' | translate }}/{{ 'GLOBAL.ESTADO' | translate }}</span>
                <span class="mc-tile__value">{{ pessoa.endereco.cidade }} - {{ pessoa.endereco.estado }}</span>
              </div>
            </div>

            <div class="mc-tile">
              <div class="mc-tile__icon">
                <i class="pi pi-barcode"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.CEP' | translate }}</span>
                <span class="mc-tile__value">{{ formatarCEP(pessoa.endereco.codPostal) }}</span>
              </div>
            </div>

            <div class="mc-tile">
              <div class="mc-tile__icon">
                <i class="pi pi-globe"></i>
              </div>
              <div class="mc-tile__data">
                <span class="mc-tile__label">{{ 'GLOBAL.PAIS' | translate }}</span>
                <span class="mc-tile__value">{{ pessoa.endereco.pais }}</span>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </section>
  </div>
</div>

  @if ($modalRenovarAberta() && $sistemaExpiradoId()) {
  <lib-renovar-plano-modal
    [sistemaId]="$sistemaExpiradoId()!"
    [pessoaId]="pessoaId"
    (fechar)="$modalRenovarAberta.set(false)"
  />
  }

  @if ($modalSenhaAberta() && !pessoa.contaOAuth) {
  <lib-redefinir-senha-conta
    [email]="pessoa.email ?? ''"
    [telefone]="pessoa.telefone ?? ''"
    (fechar)="fecharRedefinirSenha()"
  />
  }
}

<lib-completar-cadastro-modal />
